import { IEvent } from "@Interfaces";
import { useNeedUserInputToProceed } from "@Modules/eventPage/utils/useNeedUserInputToProceed";
import {
    isEmpty,
    getListingIsClass,
    useEventDataOfSelectedEvent,
} from "@Utils";
import { usePlanDropdownBaseProps } from "../../utils/plan";
import { IPlanOverhang } from "./IPlanOverhang";

export const usePlanOverhang = ({
    urlQueryParams,
    planDropdownRef,
}: IPlanOverhang.IProps) => {
    const { event, eventData = {} as IEvent.IEventData } =
        useEventDataOfSelectedEvent();
    const {
        paymentInfo: { slots },
    }: IEvent.IStore = event;

    const {
        needUserInputToProceedData: {
            needUserInputToProceed,
            messageForUserToProceed,
        },
    } = useNeedUserInputToProceed();

    const { planMetadata, planListings } = usePlanDropdownBaseProps({
        urlQueryParams,
    });

    const listingIsClass = getListingIsClass(eventData.type);

    const classText =
        (!isEmpty(slots) &&
            ((eventData.classes || []).find(c => c.uuid === slots[0]) || {})
                .timings) ||
        "Select a Class";
    const planText =
        ((!needUserInputToProceed ||
            (needUserInputToProceed &&
                messageForUserToProceed !==
                    "Please select an offering before proceeding")) &&
            (
                planListings.find(
                    p => p.plan_listing_map_uuid === eventData.uuid
                ) || {}
            ).title) ||
        planMetadata?.default_plan_text ||
        "Select a Plan";

    return {
        listingIsClass,
        classText,
        planText,
        onClick: () => {
            planDropdownRef?.current?.scrollIntoView({
                behavior: "smooth",
            });
        },
    };
};
